var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugChademoMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36,20c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S38.2060547,20,36,20z M36,26 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S37.1025391,26,36,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S14.2060547,20,12,20z M12,26 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S13.1025391,26,12,26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.2929688,7.2929688 24,10.5859375 20.7070312,7.2929688 19.2929688,8.7070312 22.5859375,12  19.2929688,15.2929688 20.7070312,16.7070312 24,13.4140625 27.2929688,16.7070312 28.7070312,15.2929688 25.4140625,12  28.7070312,8.7070312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.2929688,31.2929688 24,34.5859375 20.7070312,31.2929688 19.2929688,32.7070312 22.5859375,36  19.2929688,39.2929688 20.7070312,40.7070312 24,37.4140625 27.2929688,40.7070312 28.7070312,39.2929688 25.4140625,36  28.7070312,32.7070312  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2C11.8691406,2,2,11.8691406,2,24s9.8691406,22,22,22s22-9.8691406,22-22S36.1308594,2,24,2z M24,44 C12.9716797,44,4,35.0283203,4,24S12.9716797,4,24,4s20,8.9716797,20,20S35.0283203,44,24,44z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugChademoMedium);
export default __webpack_public_path__ + "static/media/plug-chademo--medium.dd2379cb2222babda457f8237f30cf04.svg";
export { ForwardRef as ReactComponent };